// extracted by mini-css-extract-plugin
export default {"caseACocher":"CaseACocher_caseACocher__dhOvt","input":"CaseACocher_input__5olGF","label":"CaseACocher_label__lMgbN"};